export default {
  slogan: "随时随地，爱上交易",
  download_item_name: "Pionex派网",
  download_item_desc: "点击下载前往TestFlight下载最新版本",
  download_item_question: "安装有问题?",
  download_item_click_tip: "点击获取解决方法",
  download_drawer_title: "安装常见问题",
  download_drawer_tip1: "我的TestFlight无法使用?",
  download_drawer_tip2: "需要填写兑换码?",
  download_drawer_invite_code_issue:
    "点击取消，关闭兑换码后再次点击下载，反复尝试后如果还是需要填写验证码，可以尝试切换网络",
  download_drawer_connect_issue:
    "可切换至海外网络后再访问TestFlight。如果无法访问海外网络，可使用海外Apple ID（苹果账号）直接在App Store内搜索“Pionex”下载。",
  download_drawer_button_acquire_id: "获取海外ID和教程",
  download_drawer_button_human_service: "没有解决？联系人工客服",
  download_drawer_button_human_service_title: "人工客服",
  download_drawer_button_human_service_desc: "微信扫码添加人工客服",
  download_tutor_click_hint: "点击右上角的",
  download_tutor_open_safari_hint: "选择“在Safari中打开”",
  download_tutor_open_browser_hint: "选择“在浏览器中打开”",
  download_tutor_pionex_desc1: "全自动低买高卖",
  download_tutor_pionex_desc2: "网格交易选派网",
  download_android_item_desc: "点击下载APK文件",
  download_tutor_bottom_slogan: "派网·全球首家量化交易所",

  homepage_downloadapp_ios: "iOS",
  homepage_downloadapp_android: "Android",
  homepage_downloadapp_title: "随时随地，爱上交易",
  download_button_text: "下载",
  down_load_gp_version: "Google Play版本",
  down_load_gp_version_desc: "从Google Play下载",
  down_load_apk_version: "APK版本",
  down_load_apk_version_desc: "直接下载apk文件来安装",
  down_load_app_store_version: "AppStore版本",
  down_load_app_store_version_desc: "中国大陆地区暂不支持从AppStore下载",
  down_load_testflight_version: "TestFlight版本",
  down_load_testflight_version_desc: "从TestFlight上下载，体验最新功能",
  down_from: "下载自",
  down_apk: "下载客户端",
  scan_qr_download: "iOS & Android 扫码下载",
  appstore_url: "https://apps.apple.com/us/app/pionex/id1485348891",
  gp_url:
    "https://play.google.com/store/apps/details?id=com.pionex.client&referrer=utm_source%3Dofficialweb",
  samsung_store_url:
    "https://apps.samsung.com/appquery/appDetail.as?appId=com.pionex.client",
  testflight_url: "https://testflight.apple.com/join/u47GoiJL",
};
